import { createSelector } from 'reselect';

const getLiveFeed = (state) => {
    const { liveData } = state.gumbo;
    const storePlays = liveData?.plays || {};
    const { playsByInning = [] } = storePlays;

    return playsByInning;
};

const getLoading = (state) => state.loading?.isLoading;

export const getLiveFeedState = createSelector(
    [getLiveFeed, getLoading],
    (liveFeed = [], loading) => ({
        isLoading: loading,
        playsByInning: liveFeed
    })
);
